function numberOfSelections (market) {
  var result = 0

  if (market && market.selections && market.selections.length > 0) {
    result = market.selections.filter(sel => sel.idfoselectionsuspensiontype !== 'N/O').length
  }

  return result
}

function isHad (market) {
  var selections = null

  if (market.selections) {
    selections = market.selections.filter(sel => sel.hadvalue === 'H').length > 0 ||
      market.selections.filter(sel => sel.hadvalue === 'D').length > 0 ||
      market.selections.filter(sel => sel.hadvalue === 'A').length > 0 ||
      market.selections.filter(sel => sel.hadvalue === 'U').length > 0
  }

  return Boolean(selections)
}

function isMultiHad (market) {
  var result = false

  if (market && market.selections && market.selections.length > 0) {
    result = market.selections.filter(sel => sel.hadvalue === 'H').length > 1 ||
      market.selections.filter(sel => sel.hadvalue === 'D').length > 1 ||
      market.selections.filter(sel => sel.hadvalue === 'A').length > 1 ||
      market.selections.filter(sel => sel.hadvalue === 'U').length > 1
  }

  return Boolean(result)
}

function isBig3Market (market) {
  var result = false

  if (market) {
    result = ['ML', 'PS', 'TP'].indexOf(market.big3markettype) > -1 && market.gameperiod === '1+'
  }

  return result
}

function isOutright (market) {
  var result = false

  if (market) {
    result = market.isoutright
  }

  return result
}

function isMoneyline (market) {
  return doWithMarket(market, function () {
    var result = false
    result = ['HA', 'HAD'].indexOf(market.idfohadtype) > -1 &&
             !market.isunderover &&
             !market.normalizedhandicapvalue &&
             numberOfSelections(market) <= 3

    switch (market.idfosporttype) {
      case 'TENNIS':
      case 'BOXING':
      case 'MMA':
        result = result && market.gameperiod === '1+' && numberOfSelections(market) === 2
        break
      case 'SOCCER':
        result = result && market.gameperiod === '1-2' && numberOfSelections(market) === 3
        break

      default:
        result = result && market.gameperiod === '1+'
    }

    return result
  })
}

function getBig3Markets (markets) {
  var result = []

  if (markets) {
    result = markets.filter(mk => isBig3Market(mk))
  }

  return result
}

function getFirstBig3Markets (markets) {
  var result = []

  if (markets) {
    var temp = getBig3Markets(markets)

    result.push(temp.find(mk => mk.big3markettype === 'ML'))
    result.push(temp.find(mk => mk.big3markettype === 'PS'))
    result.push(temp.find(mk => mk.big3markettype === 'TP'))

    result = result.filter(mk => Boolean(mk))
  }

  return result
}

function doWithMarket (market, callback) {
  var result = false

  if (market) {
    result = callback()
  }

  return result
}

export default {
  numberOfSelections,
  isHad,
  isMultiHad,
  isBig3Market,
  isOutright,
  isMoneyline,
  getBig3Markets,
  getFirstBig3Markets
}



// WEBPACK FOOTER //
// ./src/library/betting/market.js